import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import portalSettingsManager from "utils/portalSettingsManager";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingBottom: "30px",
  },
  subheader: {
    padding: "50px 0",
  },
  subheaderDescription: {
    alignSelf: "flex-end",
  },
  pageText: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subjectsList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  subjectItem: {
    listStyle: "none",
  },
  accordionWrapper: {
    backgroundColor:
      portalSettingsManager?.application?.common.bannerColor || theme.palette.primary.main,
    color: "#FFFFFF",
    padding: "10px 15px",
    borderRadius: "4px",
    marginTop: "15px",
    lineHeight: 1.5,
    "& button:focus": {
      border: "2px solid " + theme.palette.common.white + " !important",
    },
    "& svg": {
      color: theme.palette.common.white,
      [theme.breakpoints.down("md")]: {
        fontSize: "1.2rem",
      },
    },
    "& .accordion-content": {
      marginLeft: "0px",
    },
    "& .MuiAccordionDetails-root": {
      padding: "0px",
      flexDirection: "column",
      [theme.breakpoints.down("md")]: {
        marginLeft: "0px",
      },
      "& p": {
        fontSize: "14px",
      },
    },
    "& p": { padding: "5px" },
    "& a": {
      textDecoration: "underline",
      "&:hover": {
        opacity: 0.8,
      },
      color: theme.palette.common.white,
    },
    "& ul": {
      padding: "5px 20px",
      [theme.breakpoints.down("md")]: {
        marginLeft: "20px",
      },
      fontSize: "14px",
    },
  },

  '[data-anchor="newLearningRequirement"]': {
    textDecoration: "underline",
    cursor: "pointer",
  },
  accordionTitle: {
    fontWeight: "bold",
    color: theme.palette.common.white,
  },
}));
